import WPAPI from 'wpapi';

export const wpapi = new WPAPI({ endpoint: `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_DOMAIN}/wp-json` });

wpapi.variants = wpapi.registerRoute( 'wp/v2', '/product_variant' );
wpapi.products = wpapi.registerRoute( 'wp/v2', '/product' );
wpapi.product_categories = wpapi.registerRoute( 'wp/v2', '/product_categories' );
wpapi.contact_categories = wpapi.registerRoute( 'wp/v2', '/contact_categories' );
wpapi.product_tags = wpapi.registerRoute( 'wp/v2', '/product_tag' );
wpapi.contacts = wpapi.registerRoute( 'wp/v2', '/contact' );
wpapi.search = wpapi.registerRoute( 'search', '/product' );
wpapi.news = () => wpapi.posts().embed();



// WEBPACK FOOTER //
// ./src/config/wpapi.js